import { cn } from "@utils/clsx";
import * as React from "react";

const Input = React.forwardRef(({ className, type = "text", error = false, disabled, ...rest }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      disabled={disabled}
      className={cn(
        "w-full text-sm text-gray-900",
        "bg-white border",
        error ? "border-red-500 focus:ring-red-500 focus:border-red-500" : "border-gray-300 focus:ring-blue-500 focus:border-gray-300",
        "rounded-[4px]",              // ✅ Rounded corners
        "px-4 py-2",               // ✅ Padding inside input
        "placeholder:text-gray-400",
        "focus:outline-none focus:ring-2",
        "disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-70",
        "transition-colors duration-200",
        className
      )}
      {...rest}
    />
  );
});


Input.displayName = "Input";
export { Input };
